import React, { useState, forwardRef, useImperativeHandle } from 'react';
import './DiceRoller.scss';

// On enveloppe le composant avec "forwardRef" pour qu'il puisse recevoir une commande externe
const DiceRoller = forwardRef(({ onRollComplete, activePlayerColor, disabled, onRollClick }, ref) => {
    const [isRolling, setIsRolling] = useState(false);
    const [targetYPercent, setTargetYPercent] = useState(0);
    const [transitionDuration, setTransitionDuration] = useState('0s');
    
    const reelNumbers = Array.from({ length: 60 }, (_, i) => (i % 6) + 1);

    // On expose une fonction vers l'extérieur (ex: lancer depuis manette)
    useImperativeHandle(ref, () => ({
        lancerDepuisManette(resultatImpose) {
            lancerLeDe(resultatImpose);
        }
    }));

    const lancerLeDe = (resultatImpose) => {
        if (isRolling) return;
        setIsRolling(true);

        const audioRoueDing = new Audio('/Sound/roueDing.mp3');
        audioRoueDing.volume = 0.6; 
        audioRoueDing.play().catch(error => console.log("Erreur son roulette :", error));

        setTransitionDuration('0s');
        setTargetYPercent(0);

        setTimeout(() => {
            const resultatFinal = (typeof resultatImpose === 'number' && resultatImpose >= 1 && resultatImpose <= 6) 
                ? resultatImpose 
                : Math.floor(Math.random() * 6) + 1;
            const tours = 8;
            const indexCible = (tours * 6) + (resultatFinal - 1);
            
            // Calcul parfait en pourcentage basé sur le nombre total d'éléments (indépendant de la taille de l'écran)
            const target = (indexCible / reelNumbers.length) * 100;
            
            setTransitionDuration('2.5s');
            setTargetYPercent(target);

            setTimeout(() => {
                setIsRolling(false);
                if (onRollComplete) {
                    onRollComplete(resultatFinal);
                }
            }, 1800); 
        }, 50);
    };

    return (
        <div className="dice-container">
            {/* Flèche direction le dé avec inscription "A vous de jouer" animée horizontalement */}
            {(!disabled && !isRolling) && (
                <div className="dice-turn-hint">
                    <span className="hint-text">A vous de jouer</span>
                    <span className="hint-arrow">➔</span>
                </div>
            )}

            <button 
                className="btn-lancer" 
                onClick={onRollClick || lancerLeDe} 
                disabled={isRolling || disabled}
                style={{ backgroundColor: activePlayerColor }}
                title="Lancer le dé"
            >
                🎲
            </button>

            <div className="slot-machine-window">
                <div 
                    className="reel" 
                    style={{ 
                        transform: `translateY(-${targetYPercent}%)`,
                        transition: `transform ${transitionDuration} cubic-bezier(0.15, 0.85, 0.15, 1)` 
                    }}
                >
                    {reelNumbers.map((num, index) => (
                        <div key={index} className="reel-item">
                            {num}
                        </div>
                    ))}
                </div>
                <div className="slot-machine-shadow"></div>
            </div>
        </div>
    );
});

export default DiceRoller;